module.exports = __webpack_public_path__ + "static/gin-thumbnail-78c288bebbcf0dbf601ea3aea7ad69bd.jpg";